import { z } from 'zod';
import { ProdutoUnidadeSchema } from './ProdutoUnidade';

/** Informe o preço unitário ao utilizar este código de barras */
export enum ProdutoPacoteBarraTipoPreco {
    IgualPrecoCadastro = 1,
    AcrescentarPrecoCadastro = 2,
    DescontarPrecoCadastro = 3,
    PrecoPersonalizado = 4,
}

export const ProdutoPacoteBarraSchema = z.object({
    pcb_cod_barra: z.string().nullable(),
    pcb_descricao: z.string().nullable(),
    pcb_empresa_idpk: z.number(),
    pcb_estoque_idpk: z.number().int().nullable(),
    pcb_exibir_catalogo: z.enum(['S', 'N']),
    pcb_idpk: z.number(),
    pcb_multiplicador: z.number().nullable(),
    pcb_peso_bruto: z.number(),
    pcb_peso_liquido: z.number(),
    pcb_produto_idpk: z.number(),
    pcb_produto_unidade_idpk: z.number(),
    pcb_tipo_preco: z.enum(ProdutoPacoteBarraTipoPreco),
    pcb_ultima_alteracao: z.string(),
    pcb_valor: z.number(),
    pcb_volume_qtde: z.number(),
    produto_unidade: ProdutoUnidadeSchema.nullable(),
});

export type ProdutoPacoteBarra = z.infer<typeof ProdutoPacoteBarraSchema>;
